import React from 'react';
import './CSS/WhyFixinn.css';
import girlImage from '../assets/images/girl1.png';

const ServiceWhyFixinn = ({ service }) => {
  return (
    <section className="why-fixinn-section">
      <div className="container">
        <div className="why-fixinn-content">
          {/* Left Column */}
          <div className="why-fixinn-left">
            <div className="why-fixinn-header">
              <h2 className="why-fixinn-title">
                Why <span className="text-primary">fixINN</span>? Because
                You Deserve <span className="text-primary">Better Service.</span>
              </h2>
              <p className="why-fixinn-description">
                At fixINN, we combine expert hands, personalized care, and fast
                turnaround — so your devices, routines, and lifestyle stay stress-free.
              </p>
            </div>

            <div className="why-fixinn-features">
              {service.why_choose.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon">
                    <img src={feature.icon} alt={feature.title} />
                  </div>
                  <div className="feature-content">
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="why-fixinn-right">
            <div className="why-fixinn-girl-wrapper">
              <img src={service.personImage} alt="Happy customer with phone" className="why-fixinn-girl-image" />
              <div className="ellipse-background"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceWhyFixinn;
